function isFederationComponent(obj) {
  return !!obj && typeof obj === "object" && "__isComponent" in obj;
}
function isFederationEntry(obj) {
  return !!obj && typeof obj === "object" && "__isEntry" in obj;
}
function useEventTarget() {
  const subscribers = /* @__PURE__ */ new Map();
  return {
    subscribe,
    publish
  };
  function publish(event, ...data) {
    var _a;
    (_a = subscribers.get(event)) == null ? void 0 : _a.forEach((fn) => fn(...data));
  }
  function subscribe(event, fn) {
    if (!subscribers.has(event)) {
      subscribers.set(event, []);
    }
    subscribers.get(event).push(fn);
    return () => {
      const left = subscribers.get(event).filter((subscriber) => subscriber !== fn);
      if (left.length === 0) {
        subscribers.delete(event);
      } else {
        subscribers.set(event, left);
      }
    };
  }
}
export {
  isFederationEntry as a,
  isFederationComponent as i,
  useEventTarget as u
};
//# sourceMappingURL=helpers.js.map
